import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useAutoTicketingData = () => {
    const getAutoTicketingData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}flight/auto-ticketing${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAutoTicketingData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}flight/auto-ticketing${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}flight/auto-ticketing${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAutoTicketingData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}flight/auto-ticketing${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAutoTicketingData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}flight/auto-ticketing${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAutoTicketingData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}flight/auto-ticketing${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAutoTicketingData,
        postAutoTicketingData,
        putAutoTicketingData,
        patchAutoTicketingData,
        deleteAutoTicketingData
    };

};